export default __webpack_public_path__ + "static/media/loadingbrain-purple.5ce7a5b8.svg";